var gmaps = require('./gmaps'),
    $ = require('jquery');

export class QuantityMap {
  private $el;

  constructor(private containerId) {

    this.$el = $('#' + containerId);

    gmaps.initQuantityMap({ containerId: containerId, data: this.$el.data('map-data') });
  }
}
